import { api } from "./api";
import i18n from "./i18n";

const user = {
  pending: true,
  show: {},
  onAfterLogin: false,

  loadUser: async () => {
    user.pending = true;
    try {
      let json = await api.tfetch("/whoami");

      user.isAuthorized = true;
      user.staffId = json.id;
      user.id = json.userid;
      user.isAdmin = json.admin;
      user.isGuest = json.guest;
      user.locale = json.locale ? json.locale.code : "ru";
      user.info = json;

      user.staff = await api.q("/staff/get", { id: user.staffId });
      user.extractProfile();

      if (user.locale) {
        i18n.changeLanguage(user.locale);
      }
    } catch (e) {
      user.isAuthorized = false;
      user.isAdmin = false;
      user.profile = {};
      if (api.debug) console.error(e);
    }

    if (user.isAuthorized) {
      await user.buildClassAccessMap();
    }

    user.pending = false;
    if (user.onAfterLogin) {
      user.onAfterLogin();
    }
  },

  getLiteral: (username) => {
    if (username) {
      let splitname = username.split(" ");
      return `${splitname[0] ? splitname[0][0].toUpperCase() : ""}${
        splitname[1] ? splitname[1][0].toUpperCase() : ""
      }`;
    }
  },

  extractProfile: () => {
    user.show = {};

    let info = user.info || {};

    if (info.name.first || info.name.last) {
      let firstName = info.name.first || "";
      let lastName = info.name.last || "";
      user.show.name = `${info.name.first || ""} ${info.name.last || ""}`;

      user.show.literal = `${firstName[0] ? firstName[0].toUpperCase() : ""}${
        lastName[0] ? lastName[0].toUpperCase() : ""
      }`;

      user.show.hello = `${info.name.first || ""} ${info.name.middle || ""}`;
    } else {
      user.show.name = info.profile.name || info.profile.username;
      user.show.hello = user.show.name;
      user.show.literal = user.show.name[0].toUpperCase();
    }
    user.show.admin = user.isAdmin;
    user.show.guest = user.isGuest;
    user.show.picture = info.profile.picture || false;

    user.show.role = user.staff.positionname;
    user.show.department = user.staff.areaname;
  },

  buildClassAccessMap: async () => {
    let accessMap = {};
    let classes = await api.qo("/class");
    let types = await api.qa("/type");

    for (let classId in classes) {
      let classItem = classes[classId];
      let access = classItem.access;
      accessMap[classItem.code] = access;
    }
    user.classAccess = accessMap;

    let typeMap = {};
    types.forEach((type) => {
      typeMap[type.code] = type.id;
    });
    user.types = types;
    user.typeMap = typeMap;
  },

  getTypesByClasscode(classCode) {
    return user.types.filter((type) => type.classcode === classCode);
  },

  getClassAccess(classCode, accessType = "a") {
    if (user.classAccess[classCode]) {
      if (user.classAccess[classCode][accessType]) {
        return true;
      }
    }
    return false;
  },

  isClassManageable(classCode) {
    let access = user.classAccess[classCode] || {};
    if (access.c || access.u || access.d) {
      return true;
    }
    return false;
  },

  currentGet: async (what) => {
    return await api.q("/current/" + what);
  },

  currentSet: async (what, id, code = null) => {
    let result = await api.q("/session/set/" + what, { id, code });
    return result !== false ? true : false;
  },

  logout: () => {
    api.tfetch("/sign/out", {});
    user.isAuthorized = false;
    user.profile = {};
    user.show = {};
    user.isAdmin = false;
    api.token.flush();
    document.location.href = "/";
  },
};

export default user;
